import React from 'react';

import { IFormGroupFields } from '@/types/contentful';

import { FormField } from './FormField';

interface FormGroupProps extends IFormGroupFields {
  state: any;
  errors: any;
  handleOnChange: (key: string, val: any) => void;
}

export function FormGroup({
  id,
  state,
  errors,
  formFields,
  sectionHeader,
  handleOnChange
}: FormGroupProps) {
  return (
    <div className="flex flex-col">
      {sectionHeader && (
        <h5 className="mb-6 mt-4 px-2 py-0 text-base font-medium leading-[18px]">
          {sectionHeader}
        </h5>
      )}

      {formFields.map(({ sys, fields }: any) => (
        <FormField
          {...fields}
          key={sys?.id}
          state={state}
          errors={errors}
          formGroupId={id}
          handleOnChange={handleOnChange}
        />
      ))}
    </div>
  );
}
